import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ExportPanel from '../components/ExportPanel';
import './More.css';

// Company hub — reached from the 🏢 rail item. Everything plan- or
// role-gated lives here so the sidebar rail can stay the same on every plan.
// Customers moved to the rail; Settings and Team live in the account menu
// (Team is also listed here for discoverability).
const ITEMS = [
  { to: '/company',            icon: '🏢', label: 'Company Overview', desc: 'All businesses at a glance',        ownerOnly: true, enterpriseFeature: true },
  { to: '/company/purchases',  icon: '🛒', label: 'Purchases',        desc: 'Company-wide buying',               ownerOnly: true, enterpriseFeature: true },
  { to: '/company/assets',     icon: '🏗️', label: 'Assets',           desc: 'Equipment and property',            ownerOnly: true, enterpriseFeature: true },
  { to: '/company/expenses',   icon: '💸', label: 'Company Expenses', desc: 'Costs across all businesses',       ownerOnly: true, enterpriseFeature: true },
  { to: '/company/financials', icon: '📈', label: 'Statements',       desc: 'Consolidated P&L and ratios',       ownerOnly: true, enterpriseFeature: true },
  { to: '/company/fund',       icon: '💰', label: 'Fund Tracker',     desc: 'Capital injections and cash flow',  ownerOnly: true, enterpriseFeature: true },
  { to: '/production',         icon: '🫙', label: 'Production',       desc: 'Batches and output',                managerOnly: true, proFeature: true },
  { to: '/charts',             icon: '🥧', label: 'Charts',           desc: 'Visual breakdowns of your numbers', managerOnly: true, proFeature: true },
  { to: '/financials',         icon: '📊', label: 'Financials',       desc: 'Revenue, profit and receivables',   managerOnly: true, proFeature: true },
  { to: '/expenses',           icon: '🧾', label: 'Expenses',         desc: 'Track operating costs',             managerOnly: true },
  { to: '/team',               icon: '🤝', label: 'Team',             desc: 'Invite and manage staff',           ownerOnly: true },
];

export default function More() {
  const { user, business, isPro, isEnterprise } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="page">
      <div className="more-header">
        <div>
          <div className="more-title">Company</div>
          <div className="more-biz">{business?.name}</div>
        </div>
        <div className="more-currency">{business?.currency}</div>
      </div>

      {!isEnterprise && user?.role === 'owner' && (
        <button
          onClick={() => navigate('/upgrade')}
          style={{ display: 'block', width: '100%', margin: '0 0 1rem', padding: '0.75rem 1rem', borderRadius: '10px',
            background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)', color: '#fff',
            border: 'none', cursor: 'pointer', textAlign: 'left' }}
        >
          <div style={{ fontWeight: 600, fontSize: '0.9rem', marginBottom: '0.2rem' }}>
            {isPro ? 'Upgrade to Enterprise' : 'Upgrade your plan'}
          </div>
          <div style={{ fontSize: '0.8rem', opacity: 0.9 }}>
            {isPro
              ? 'Unlock multi-business management, fund tracking, and consolidated financials.'
              : 'Add your team, run financial reports, and sync across devices — or go Enterprise for multi-business tools.'}
          </div>
        </button>
      )}

      <div className="more-list">
        {ITEMS
          .filter(item => {
            if (item.ownerOnly   && user?.role !== 'owner') return false;
            if (item.managerOnly && user?.role !== 'owner' && user?.role !== 'manager') return false;
            return true;
          })
          .map(item => (
            <Link key={item.to} to={item.to} className="more-item">
              <span className="more-icon">{item.icon}</span>
              <div className="more-text">
                <div className="more-label" style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                  {item.label}
                  {item.proFeature && !isPro && (
                    <span style={{ fontSize: '0.62rem', fontWeight: 700, background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', color: '#fff', borderRadius: '4px', padding: '0.1rem 0.3rem', letterSpacing: '0.03em' }}>PRO</span>
                  )}
                  {item.enterpriseFeature && !isEnterprise && (
                    <span style={{ fontSize: '0.62rem', fontWeight: 700, background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', color: '#fff', borderRadius: '4px', padding: '0.1rem 0.3rem', letterSpacing: '0.03em' }}>ENTERPRISE</span>
                  )}
                </div>
                <div className="more-desc">{item.desc}</div>
              </div>
              <span className="more-arrow">›</span>
            </Link>
          ))
        }
      </div>

      {/* Managers export here; owners also have this under Settings. */}
      {(user?.role === 'owner' || user?.role === 'manager') && (
        <div style={{ marginTop: '1.25rem' }}><ExportPanel /></div>
      )}
    </div>
  );
}
